// extracted by mini-css-extract-plugin
export default {"menuBlock":"SE-z","title":"TE-z","nav":"UE-z","flexCell":"VE-z","facetLink":"WE-z"};